import { User as FirebaseUser } from 'firebase/auth';

export type AuthProvider = 'email' | 'google' | 'facebook' | 'apple';

/**
 * Detecta el proveedor de autenticación principal del usuario
 * @param user - Usuario de Firebase
 * @returns El proveedor de autenticación
 */
export const detectAuthProvider = (user: FirebaseUser | null): AuthProvider => {
  if (!user || !user.providerData.length) {
    return 'email';
  }

  // Buscar el proveedor principal
  const provider = user.providerData[0];
  
  switch (provider.providerId) {
    case 'google.com':
      return 'google';
    case 'facebook.com':
      return 'facebook';
    case 'apple.com':
      return 'apple';
    case 'password':
    case 'email':
    default:
      return 'email';
  }
};

/**
 * Verifica si el usuario puede cambiar su contraseña
 * Solo los usuarios registrados con email/contraseña pueden cambiar la contraseña
 * @param provider - Proveedor de autenticación
 * @returns true si puede cambiar contraseña, false si no
 */
export const canChangePassword = (provider: AuthProvider): boolean => {
  return provider === 'email';
};

/**
 * Obtiene un nombre amigable para el proveedor de autenticación
 * @param provider - Proveedor de autenticación
 * @returns Nombre amigable del proveedor
 */
export const getProviderDisplayName = (provider: AuthProvider): string => {
  switch (provider) {
    case 'google':
      return 'Google';
    case 'facebook':
      return 'Facebook';
    case 'apple':
      return 'Apple';
    case 'email':
    default:
      return 'Email';
  }
};
